import { render } from "./BaseMetricsBlocks.vue?vue&type=template&id=6dab96b6&scoped=true"
import script from "./BaseMetricsBlocks.vue?vue&type=script&lang=js"
export * from "./BaseMetricsBlocks.vue?vue&type=script&lang=js"

import "./BaseMetricsBlocks.vue?vue&type=style&index=0&id=6dab96b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dab96b6"]])

export default __exports__